import {create} from "zustand";
import {CalendarGetResponse, CalendarState} from "./types";
import {$api} from "shared/api";
import {serializeParams} from "shared/helpers/converters";

export const useCalendarStore = create<CalendarState>((set) => ({
  events: [],
  eventsByHive: [],
  currentPage: 0,
  pageSize: 0,
  isEnd: false,
  lastParams: null,
  getEventsFromServer: async (params) => {
    const paramsClone = structuredClone?.(params) || JSON.parse(JSON.stringify(params));

    set({
      lastParams: paramsClone
    })

    if (!paramsClone.page) {
      paramsClone.page = 1;
      paramsClone.pageSize = 200;
    }

    const res = await $api.get<CalendarGetResponse>('/events', {
      params: paramsClone,
      paramsSerializer: { serialize: serializeParams },
    })

    const events = res?.data?.events || [];

    set({
      events
    })
  },
  getEventsFromServerByHive: async (params) => {
    const paramsClone = structuredClone?.(params) || JSON.parse(JSON.stringify(params));

    if (!paramsClone.page) {
      paramsClone.page = 1;
      paramsClone.pageSize = 200;
    }

    const res = await $api.get<CalendarGetResponse>('/events', {
      params: paramsClone,
      paramsSerializer: { serialize: serializeParams },
    })

    const events = res?.data?.events || [];

    set({
      eventsByHive: events
    })
  },
  addEvent: async (params) => {
    const res = await $api.post("/events", params);
    return res;
  },
  editEvent: async (params) => {
    const res = await $api.patch(`/events/${params.id}`, params);
    return res;
  },
}))